import { render, staticRenderFns } from "./ForceCreateForm.vue?vue&type=template&id=3b0c2804"
import script from "./ForceCreateForm.vue?vue&type=script&lang=js"
export * from "./ForceCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports